import styles from "./styles.module.scss";
import Section from "../../components/Section";

import git_icon from "../../graphics/git_icon.svg";
import mail_icon from "../../graphics/mail_icon.svg";
import tg_icon from "../../graphics/tg_icon.svg";
import phone_icon from "../../graphics/phone_icon.svg";
import hearts_icon from "../../graphics/hearts_icon.svg";
import o_image from "../../images/o.png";
import behance_icon from "../../graphics/behance_icon.svg";

const Contacts = () => {
  return (
    <Section color="#1D1D1D">
      <div className={styles.container}>
        <div className={styles.divider}></div>
        <div className={styles.content}>
          <div className={styles.message}>
            <div className={styles.thanks}>
              <div>
                М{" "}
                <span>
                  <img src={o_image} alt="" />
                </span>{" "}
                И
              </div>
              <div>
                К{" "}
                <span>
                  <img src={o_image} alt="" />
                </span>{" "}
                НТАКТЫ
              </div>
            </div>
            <div className={styles.attention}>
              <p>СПАСИБО ЗА ВНИМАНИЕ</p>
              <img src={hearts_icon} alt="" />
            </div>
          </div>
          <div className={styles.socials}>
            <div className={styles.item}>
              <div>
                <img src={git_icon} alt="" />
              </div>
              <a
                target="_blank"
                href="https://github.com/leiderovaviktoriia"
                className={styles.text}
              >
                leiderovaviktoriia
              </a>
            </div>
            <div className={styles.item}>
              <div>
                <img src={behance_icon} alt="" />
              </div>
              <a
                href="https://www.behance.net/viktorileidero1"
                target="_blank"
                className={styles.text}
              >
                Viktoriia Leiderova
              </a>
            </div>
            <div className={styles.item}>
              <div>
                <img src={mail_icon} alt="" />
              </div>
              <a
                href="mailto:viktoriia.leiderova@gmail.com"
                className={styles.text}
              >
                viktoriia.leiderova@gmail.com
              </a>
            </div>
            <div className={styles.item}>
              <div>
                <img src={tg_icon} alt="" />
              </div>
              <a
                target="_blank"
                href="https://t.me/viktoriialei"
                className={styles.text}
              >
                viktoriialei
              </a>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Contacts;
